import React from 'react';

const STYLES = {
  success: 'bg-emerald-500/10 border-emerald-500/25 text-emerald-300',
  error:   'bg-red-500/10 border-red-500/25 text-red-300',
  info:    'bg-brand-500/10 border-brand-400/25 text-brand-200',
  warn:    'bg-amber-500/10 border-amber-500/25 text-amber-300',
};

const ICONS = {
  success: <path d="M20 6L9 17l-5-5" />,
  error:   <path d="M18 6L6 18M6 6l12 12" />,
  info:    <><circle cx="12" cy="12" r="9" /><path d="M12 16v-5M12 8h.01" /></>,
  warn:    <><path d="M12 9v4M12 17h.01" /><path d="M10.3 3.86l-8.18 14a1.5 1.5 0 001.3 2.14h16.16a1.5 1.5 0 001.3-2.14l-8.18-14a1.5 1.5 0 00-2.6 0z" /></>,
};

export default function AlertMessage({ msg, className = 'mb-6' }) {
  if (!msg) return null;
  const type = STYLES[msg.type] ? msg.type : 'error';

  return (
    <div className={`flex items-start gap-2.5 text-sm px-4 py-3 rounded-lg border
                     ${STYLES[type]} ${className}`}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
           strokeLinecap="round" strokeLinejoin="round"
           className="w-4 h-4 flex-shrink-0 mt-0.5">
        {ICONS[type]}
      </svg>
      <span className="leading-relaxed">{msg.text}</span>
    </div>
  );
}
